<template>
  <div>
    <v-card
      v-for="(ehto, idx) of body.luovutuksenEhdot"
      :key="idx"
      class="mb-4 pb-2"
    >
      <v-card-text class="pa-6">
        <v-text-field
          v-model="ehto.title"
          :disabled="mandatoryConditionsTitles.includes(ehto.title)"
          label="Ehdon otsikko"
          hide-details
          append-outer-icon="clear"
          @change="saveConditions()"
          @click:append-outer="remove(idx)"
        />
        <v-textarea
          v-model="ehto.description"
          :disabled="mandatoryConditionsTitles.includes(ehto.title)"
          class="mt-4 mb-0"
          hide-details
          rows="1"
          auto-grow
          label="Ehdon sisältö"
          @change="saveConditions()"
        />
      </v-card-text>
    </v-card>
    <v-btn
      depressed
      color="primary"
      class="mt-3"
      @click="addRow()"
    >
      Lisää ehto
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    mandatoryConditionsTitles() {
      return this.config.data.luovutuskirjanPakollisetEhdot.map(item => item.title);
    },
  },
  methods: {
    saveConditions() {
      const mandatoryTitles = this.config
        .data.luovutuskirjanPakollisetEhdot.map(item => item.title);
      const ownConditions = this.body
        .luovutuksenEhdot.filter(i => !mandatoryTitles.includes(i.title));

      localStorage.setItem(`dias-conditions-${this.$route.params.id}`, JSON.stringify(ownConditions));
    },
    addRow() {
      this.body.luovutuksenEhdot.push({ title: '', description: '' });
    },
    remove(idx) {
      this.body.luovutuksenEhdot.splice(idx, 1);

      this.saveConditions();
    },
  },
};
</script>
